module.exports = __webpack_public_path__ + "static/media/cement.28ac2e9f.svg";